module.exports = __webpack_public_path__ + "img/kaixo.3c06b9bb.png";